import { useMediaQuery } from "@mantine/hooks";

/**
 * True while the viewport is narrower than `breakpoint` px (so the breakpoint itself is the
 * first "wide" width, matching how min-width breakpoints read in SCSS). The query is read on
 * the first render, so a narrow screen never flashes the wide layout.
 */
export function useBreakpointDown(breakpoint: number): boolean {
  return !!useMediaQuery(`(max-width: ${breakpoint - 1}px)`, undefined, {
    getInitialValueInEffect: false,
  });
}
